module.exports = __webpack_public_path__ + "img/keezlive.670f409.png";